import { useState } from "react";
import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "内容分类",
    links: [
      { label: "国内探花", path: "/category/domestic" },
      { label: "探花精选", path: "/category/selection" },
      { label: "探花91", path: "/category/tanhua91" },
      { label: "探花直播", path: "/category/live" },
      { label: "顶级大师", path: "/category/top-master" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "品牌介绍", path: "/about" },
      { label: "联系方式", path: "/about" },
      { label: "用户协议", path: "/about" },
      { label: "隐私政策", path: "/about" },
    ],
  },
];

export default function Footer() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formMessage, setFormMessage] = useState("");

  const handleSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt")?.toString().trim();
    if (honeypot) {
      setFormStatus("success");
      setFormMessage("订阅成功！感谢您的关注。");
      return;
    }
    const email = formData.get("email")?.toString().trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFormStatus("error");
      setFormMessage("请输入有效的邮箱地址");
      return;
    }
    form.reset();
    setFormStatus("success");
    setFormMessage("订阅成功！感谢您的关注。");
  };

  return (
    <footer className="bg-background-900 text-background-100 rounded-t-2xl mx-2 md:mx-4 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">探</span>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                探花系列
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-6">
              汇聚国内探花、探花精选、探花91等优质资源，打造探花爱好者必看的精品聚合平台。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors"
                aria-label="站内动态"
              >
                <i className="ri-chat-1-line w-4 h-4 flex items-center justify-center text-background-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line w-4 h-4 flex items-center justify-center text-background-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors"
                aria-label="QQ"
              >
                <i className="ri-qq-line w-4 h-4 flex items-center justify-center text-background-200"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-background-50 font-medium text-sm mb-4">
                {group.title}
              </h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label + link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="text-background-50 font-medium text-sm mb-4">
              订阅更新
            </h3>
            <p className="text-sm text-background-400 mb-4">
              订阅我们的资讯，第一时间获取最新探花系列资源更新。
            </p>
            <form
              className="flex items-center gap-2"
              onSubmit={handleSubscribe}
            >
              <div className="hp-field" aria-hidden="true">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                />
              </div>
              <div className="flex-1 relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱地址"
                  className="w-full px-3 py-2.5 bg-background-800 border border-background-700 rounded-md text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors shrink-0"
                aria-label="订阅"
              >
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-background-50"></i>
              </button>
            </form>
            {formStatus !== "idle" && (
              <p
                className={`mt-2 text-xs ${
                  formStatus === "success" ? "text-primary-400" : "text-accent-400"
                }`}
              >
                {formMessage}
              </p>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              © 2024 探花系列精品聚合平台 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <Link to="/about" className="hover:text-background-300 transition-colors">
                关于我们
              </Link>
              <span className="text-background-700">|</span>
              <Link to="/about" className="hover:text-background-300 transition-colors">
                用户协议
              </Link>
              <span className="text-background-700">|</span>
              <Link to="/about" className="hover:text-background-300 transition-colors">
                隐私政策
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
